var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { sendOtpWrapper, verifyOtpWrapper } from '@/api/authService';
import IconRightCheck from '@/components/icons/IconRightCheck';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import OTPInput from 'react-otp-input';
import Popup from './Popup';
import Button from './common/Button';
import InputField from './common/InputField';
import { useConfigContext, useToast } from '@/hoc';
import { checkUserExist } from '@/api/userService';
var VerifyEmailModal = function (_a) {
    var email = _a.email, isOpen = _a.isOpen, onEmailVerify = _a.onEmailVerify, onClose = _a.onClose;
    var _b = useForm(), register = _b.register, handleSubmit = _b.handleSubmit, errors = _b.formState.errors;
    var showToast = useToast().showToast;
    var _c = useState(120), timeLeft = _c[0], setTimeLeft = _c[1];
    var _d = useState(false), isTimerActive = _d[0], setIsTimerActive = _d[1];
    var _e = useState(1), step = _e[0], setStep = _e[1];
    var _f = useState(''), otp = _f[0], setOtp = _f[1];
    var _g = useState(''), otpError = _g[0], setOtpError = _g[1];
    var _h = useState(false), showOTPField = _h[0], setShowOTPField = _h[1];
    var _j = useState(false), isLoading = _j[0], setIsLoading = _j[1];
    var _k = useState(), userId = _k[0], setUserId = _k[1];
    var config = useConfigContext().config;
    useEffect(function () {
        var timerInterval = null;
        if (isTimerActive && timeLeft > 0) {
            timerInterval = setInterval(function () { return setTimeLeft(function (prevTime) { return prevTime - 1; }); }, 1000);
        }
        else if (timeLeft === 0) {
            setIsTimerActive(false);
        }
        return function () {
            if (timerInterval)
                clearInterval(timerInterval);
        };
    }, [isTimerActive, timeLeft]);
    useEffect(function () {
        if (showOTPField) {
            setIsTimerActive(true);
            setTimeLeft(120);
        }
    }, [showOTPField]);
    var formatTime = function (seconds) {
        var minutes = Math.floor(seconds / 60);
        var remainingSeconds = seconds % 60;
        return "".concat(String(minutes).padStart(2, '0'), ":").concat(String(remainingSeconds).padStart(2, '0'));
    };
    var handleResendOtp = function () { return __awaiter(void 0, void 0, void 0, function () {
        var sendOtpWrapperResponse;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(email && userId)) return [3 /*break*/, 2];
                    return [4 /*yield*/, sendOtpWrapper(email, userId, config === null || config === void 0 ? void 0 : config.sendVerifyEmailOtpRoute)];
                case 1:
                    sendOtpWrapperResponse = _b.sent();
                    if (sendOtpWrapperResponse.status === 200) {
                        showToast({
                            message: (_a = sendOtpWrapperResponse === null || sendOtpWrapperResponse === void 0 ? void 0 : sendOtpWrapperResponse.data) === null || _a === void 0 ? void 0 : _a.message,
                            status: 'success',
                        });
                        setOtp('');
                        setOtpError('');
                        setShowOTPField(true);
                    }
                    else {
                        showToast({
                            message: sendOtpWrapperResponse.message,
                            status: 'error',
                        });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    showToast({
                        message: 'UserID or Email not found',
                        status: 'error',
                    });
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var closeModal = function () {
        if (step === 2) {
            onEmailVerify();
        }
        onClose();
    };
    var handleStepOneSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var userData, emailVerfiyRequestResponse, emailVerifyResponse;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setIsLoading(true);
                    if (!(!showOTPField && email)) return [3 /*break*/, 5];
                    return [4 /*yield*/, checkUserExist(email, config === null || config === void 0 ? void 0 : config.isExistsRoute)];
                case 1:
                    userData = _c.sent();
                    if (!((_a = userData === null || userData === void 0 ? void 0 : userData.data) === null || _a === void 0 ? void 0 : _a.is_exists)) return [3 /*break*/, 3];
                    setUserId(userData.data.user.id);
                    return [4 /*yield*/, sendOtpWrapper(email, userData.data.user.id, config === null || config === void 0 ? void 0 : config.sendVerifyEmailOtpRoute)];
                case 2:
                    emailVerfiyRequestResponse = _c.sent();
                    if (emailVerfiyRequestResponse.status === 200) {
                        setShowOTPField(true);
                        showToast({
                            message: (_b = emailVerfiyRequestResponse === null || emailVerfiyRequestResponse === void 0 ? void 0 : emailVerfiyRequestResponse.data) === null || _b === void 0 ? void 0 : _b.message,
                            status: 'success',
                        });
                    }
                    else {
                        showToast({
                            message: emailVerfiyRequestResponse.message,
                            status: 'error',
                        });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    showToast({
                        message: 'User does not exists',
                        status: 'error',
                    });
                    _c.label = 4;
                case 4: return [3 /*break*/, 8];
                case 5:
                    if (!(showOTPField && otp.length === 6 && userId)) return [3 /*break*/, 7];
                    return [4 /*yield*/, verifyOtpWrapper(userId, Number(otp), config === null || config === void 0 ? void 0 : config.verifyEmailRoute)];
                case 6:
                    emailVerifyResponse = _c.sent();
                    if (emailVerifyResponse.status === 'error') {
                        showToast({
                            message: emailVerifyResponse.message,
                            status: 'error',
                        });
                    }
                    else {
                        setStep(2);
                    }
                    return [3 /*break*/, 8];
                case 7:
                    showToast({
                        message: 'Please enter a 6-digit OTP',
                        status: 'error',
                    });
                    _c.label = 8;
                case 8:
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [step === 1 && (_jsx(Popup, { isOpen: isOpen, onClose: closeModal, title: 'Verifiy Your Email', className: '!vas-z-100000', children: _jsxs("form", { onSubmit: handleSubmit(handleStepOneSubmit), className: 'vas-w-full vas-flex vas-flex-col vas-gap-4', children: [_jsx(InputField, __assign({ type: 'text', value: email, placeholder: 'Enter your valid Email ID', label: 'Email ID', required: true }, register('emailOrMobile', {
                            required: 'Email or Mobile number is required',
                            pattern: {
                                value: /^[0-9]{10}$|^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                message: 'Enter a valid email or 10-digit mobile number',
                            },
                        }), { inputClass: 'vas-w-full vas-p-2 vas-border vas-rounded-lg focus:vas-outline-none', labelClass: 'vas-block vas-text-vastypographyLabelsTextColor vas-text-vastypographyLabelsFontSize vas-font-vastypographyLabelsFontWeight', error: errors.emailOrMobile })), showOTPField && (_jsxs(_Fragment, { children: [_jsxs("div", { className: 'vas-flex vas-justify-between vas-items-center vas-mt-2 vas-text-sm', children: [_jsx("div", { className: 'vas-text-sm vas-text-vastypographyLabelsTextColor', children: formatTime(timeLeft) }), _jsx(Button, { onClick: function () {
                                                handleResendOtp();
                                                setIsTimerActive(true);
                                                setTimeLeft(120);
                                            }, className: "".concat(isTimerActive ? 'vas-text-gray-400' : 'vas-text-primary', " !vas-bg-white vas-cursor-pointer vas-underline"), disabled: isTimerActive, children: "Resend OTP" })] }), _jsx("label", { className: 'vas-block vas-text-vastypographyLabelsTextColor vas-text-vastypographyLabelsFontSize vas-mt-2', children: "Enter OTP sent to your Email ID." }), _jsx(OTPInput, { value: otp, onChange: function (e) {
                                        setOtp(e);
                                        setOtpError('');
                                    }, numInputs: 6, containerStyle: 'vas-flex vas-justify-center vas-space-x-2', renderInput: function (props) { return (_jsx("input", __assign({}, props, { placeholder: '-', className: 'vas-text-center !vas-w-12 !vas-h-12 vas-text-lg vas-rounded-lg vas-font-semibold focus:vas-outline-none vas-border vas-border-gray-300' }))); } }), otpError && (_jsx("span", { className: 'vas-text-vasDanger vas-text-vastypographyLabelsFontSize', children: otpError }))] })), _jsx(Button, { isLoading: isLoading, type: 'submit', className: "vas-text-white vas-mt-4 vas-w-full vas-p-2 vas-rounded-lg ".concat(isLoading ? 'vas-cursor-not-allowed vas-bg-gray-400' : 'vas-bg-primary'), children: showOTPField ? 'Verify OTP' : 'Send OTP' })] }) })), step === 2 && (_jsx(Popup, { className: '!vas-z-100000', isOpen: step === 2, onClose: closeModal, children: _jsxs("div", { className: 'vas-flex vas-flex-col vas-justify-center vas-items-center vas-gap-1', children: [_jsx(IconRightCheck, {}), _jsx("h2", { className: 'vas-font-vastypographySubheadingFontWeight vas-text-vastypographySubHeadingTextColor vas-text-vastypographyHeadingFontSize', children: "Otp Verified!" }), _jsx("p", { className: 'vas-text-center vas-text-vastypographyLabelsTextColor vas-font-normal vas-text-vastypographyLabelsFontSize', children: "Your OTP has been successfully Verfied." }), _jsx(Button, { onClick: function () {
                                closeModal();
                            }, className: 'vas-mt-4 vas-w-24 vas-p-2 vas-text-white vas-rounded-full vas-bg-primary', children: "Okay" })] }) }))] }));
};
export default VerifyEmailModal;
